webpackJsonp([45],{

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__(796);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d986a78e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__(861);
function injectStyle (ssrContext) {
  __webpack_require__(859)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d986a78e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d986a78e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app-header',
  computed: {
    appName: {
      get: function get() {
        return this.$store.getters['app/name'];
      }
    },
    appVersion: {
      get: function get() {
        return this.$store.getters['app/version'];
      }
    },
    url: {
      get: function get() {
        return this.$store.getters['wordpress/account/url'];
      }
    },
    username: {
      get: function get() {
        return this.$store.getters['wordpress/account/username'];
      }
    }
  }
});

/***/ }),

/***/ 859:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(860);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("723b2f0d", content, true, {});

/***/ }),

/***/ 860:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".header[data-v-d986a78e]{width:100%;height:0;color:#999;background-color:#2c2c36}.header-h1[data-v-d986a78e]{font-size:1.2em;font-weight:400}.header-a[data-v-d986a78e]{font-size:.8em}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/app/AppHeader.vue"],"names":[],"mappings":"AAsBA,yBACE,WAAY,AACZ,SAAU,AACV,WAAY,AACZ,wBAA0B,CAC3B,AACD,4BACI,gBAAiB,AACjB,eAAoB,CACvB,AACD,2BACI,cAAgB,CACnB","file":"AppHeader.vue","sourcesContent":["/**\n *\n * Layout\n *\n */\n/**\n * Columns\n */\n/**\n * Component\n */\n/**\n *\n * Application specific variables\n *\n */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Menu\n--------------------------*/\n.header[data-v-d986a78e] {\n  width: 100%;\n  height: 0;\n  color: #999;\n  background-color: #2c2c36;\n}\n.header-h1[data-v-d986a78e] {\n    font-size: 1.2em;\n    font-weight: normal;\n}\n.header-a[data-v-d986a78e] {\n    font-size: .8em;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 861:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header flex justify-between items-center px4"},[_c('h1',{staticClass:"header-h1"},[_vm._v(_vm._s(_vm.appName))]),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(_vm.appVersion))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.user.username)+" @")]),_vm._v(" "),_c('a',{staticClass:"header-a",attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.url))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/45.076a11a6284810d0fb8b.js